/**
 * Halı özelleştirme bloğu (_rug-options)
 *
 * - Kenar işçiliği seçimi -> line item property olarak sepete gider
 * - Sipariş notu -> line item property
 * - Özel ölçü: en/boy/adet ile canlı m² ve tahmini tutar, ardından teklif formu
 *
 * Bağımsız (module olmayan) script; tema JS'ine bağımlılığı yoktur.
 */
(function () {
  "use strict";

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === "undefined" ? 2 : precision;
    thousands = typeof thousands === "undefined" ? "," : thousands;
    decimal = typeof decimal === "undefined" ? "." : decimal;
    if (isNaN(number) || number === null) return "0";
    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split(".");
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    return whole + (parts[1] ? decimal + parts[1] : "");
  }

  function formatMoney(cents) {
    var format =
      (window.cartStrings && window.cartStrings.money_format) ||
      (window.themeGlobalVariables &&
        window.themeGlobalVariables.settings &&
        window.themeGlobalVariables.settings.money_format) ||
      "{{amount}}";
    var match = format.match(PLACEHOLDER);
    if (!match) return String(Math.round(cents) / 100);
    var value;
    switch (match[1]) {
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(PLACEHOLDER, value);
  }

  function formatNumber(value, decimals) {
    try {
      return value.toLocaleString("tr-TR", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });
    } catch (e) {
      return value.toFixed(decimals);
    }
  }

  function toNumber(input) {
    if (!input) return NaN;
    var raw = String(input.value).trim().replace(",", ".");
    if (raw === "") return NaN;
    return parseFloat(raw);
  }

  function RugOptions(root) {
    this.root = root;
    this.formId = root.getAttribute("data-form-id");
    this.productForm = this.formId ? document.getElementById(this.formId) : null;
    this.stickyFormId = root.getAttribute("data-sticky-form-id");

    this.edgeGroup = root.querySelector("[data-edge-group]");
    this.edgeRequired = root.getAttribute("data-edge-required") === "true";
    this.noteInput = root.querySelector("[data-note-input]");
    this.noteCounter = root.querySelector("[data-note-counter]");

    this.custom = root.querySelector("[data-custom]");
    this.dialog = root.querySelector("[data-quote-dialog]");

    this.bindEdge();
    this.bindNote();
    this.bindCustom();
    this.bindDialog();
    this.bindAddToCartGuard();
  }

  /* ---------- Yapışkan çubuk (sticky add to cart) ----------

     Sticky çubuk kendi ayrı formunu kullanıyor
     (sticky-addcart-form-<section.id>), bizim inputlar oraya bağlı değil.
     Submit'ten hemen önce değerleri o forma gizli input olarak kopyalıyoruz. */

  RugOptions.prototype.stickyForm = function () {
    return this.stickyFormId ? document.getElementById(this.stickyFormId) : null;
  };

  RugOptions.prototype.mirrorInto = function (form) {
    if (!form) return;
    var self = this;
    var pairs = [];

    if (this.edgeGroup) {
      var checked = this.edgeGroup.querySelector("input:checked");
      if (checked) pairs.push([checked.name, checked.value]);
    }
    if (this.noteInput && this.noteInput.value.trim()) {
      pairs.push([this.noteInput.name, this.noteInput.value]);
    }

    // Önceki kopyaları temizle, güncel değerleri yaz.
    var stale = form.querySelectorAll("[data-rug-mirror]");
    Array.prototype.forEach.call(stale, function (el) {
      el.parentNode.removeChild(el);
    });

    pairs.forEach(function (pair) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = pair[0];
      input.value = pair[1];
      input.setAttribute("data-rug-mirror", "true");
      form.appendChild(input);
    });

    return self;
  };

  /* ---------- Kenar işçiliği ---------- */

  RugOptions.prototype.selectedEdge = function () {
    if (!this.edgeGroup) return "";
    var checked = this.edgeGroup.querySelector("input:checked");
    return checked ? checked.value : "";
  };

  RugOptions.prototype.bindEdge = function () {
    if (!this.edgeGroup) return;
    var self = this;
    this.edgeGroup.addEventListener("change", function () {
      self.edgeGroup.classList.remove("is-invalid");
    });
  };

  RugOptions.prototype.validateEdge = function () {
    if (!this.edgeGroup || !this.edgeRequired) return true;
    var ok = !!this.selectedEdge();
    this.edgeGroup.classList.toggle("is-invalid", !ok);
    if (!ok) {
      this.edgeGroup.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return ok;
  };

  /* ---------- Sipariş notu ---------- */

  RugOptions.prototype.bindNote = function () {
    if (!this.noteInput || !this.noteCounter) return;
    var self = this;
    var max = parseInt(this.noteInput.getAttribute("maxlength"), 10) || 0;
    var update = function () {
      self.noteCounter.textContent = self.noteInput.value.length + " / " + max;
    };
    this.noteInput.addEventListener("input", update);
    update();
  };

  /* ---------- Özel ölçü ---------- */

  RugOptions.prototype.bindCustom = function () {
    if (!this.custom) return;
    var self = this;

    this.toggle = this.custom.querySelector("[data-custom-toggle]");
    this.panel = this.custom.querySelector("[data-custom-panel]");
    this.widthInput = this.custom.querySelector("[data-custom-width]");
    this.heightInput = this.custom.querySelector("[data-custom-height]");
    this.qtyInput = this.custom.querySelector("[data-custom-qty]");
    this.summary = this.custom.querySelector("[data-custom-summary]");
    this.areaEl = this.custom.querySelector("[data-custom-area]");
    this.priceEl = this.custom.querySelector("[data-custom-price]");
    this.errorEl = this.custom.querySelector("[data-custom-error]");
    this.quoteButton = this.custom.querySelector("[data-quote-open]");

    this.m2Cents = parseFloat(this.custom.getAttribute("data-m2-cents")) || 0;
    this.surcharge = parseFloat(this.custom.getAttribute("data-surcharge")) || 0;
    this.limits = {
      minW: parseFloat(this.custom.getAttribute("data-min-width")) || 0,
      maxW: parseFloat(this.custom.getAttribute("data-max-width")) || 0,
      minH: parseFloat(this.custom.getAttribute("data-min-height")) || 0,
      maxH: parseFloat(this.custom.getAttribute("data-max-height")) || 0,
    };

    if (this.toggle && this.panel) {
      this.toggle.addEventListener("click", function () {
        var open = self.toggle.getAttribute("aria-expanded") === "true";
        self.toggle.setAttribute("aria-expanded", String(!open));
        self.panel.hidden = open;
      });
    }

    [this.widthInput, this.heightInput, this.qtyInput].forEach(function (el) {
      if (!el) return;
      el.addEventListener("input", function () {
        self.custom.classList.remove("is-invalid");
        self.updateSummary();
      });
    });

    if (this.quoteButton) {
      this.quoteButton.addEventListener("click", function () {
        self.openQuote();
      });
    }

    this.updateSummary();
  };

  RugOptions.prototype.readCustom = function () {
    var w = toNumber(this.widthInput);
    var h = toNumber(this.heightInput);
    var qty = toNumber(this.qtyInput);
    if (isNaN(qty) || qty < 1) qty = 1;
    return { width: w, height: h, qty: Math.floor(qty) };
  };

  RugOptions.prototype.customErrors = function (values) {
    var l = this.limits;
    var errors = [];
    if (isNaN(values.width) || isNaN(values.height)) {
      errors.push("Lütfen en ve boy değerlerini girin.");
      return errors;
    }
    if (l.minW && values.width < l.minW) {
      errors.push("En en az " + l.minW + " cm olabilir.");
    }
    if (l.maxW && values.width > l.maxW) {
      errors.push("En en fazla " + l.maxW + " cm olabilir.");
    }
    if (l.minH && values.height < l.minH) {
      errors.push("Boy en az " + l.minH + " cm olabilir.");
    }
    if (l.maxH && values.height > l.maxH) {
      errors.push("Boy en fazla " + l.maxH + " cm olabilir.");
    }
    return errors;
  };

  RugOptions.prototype.computeCustom = function (values) {
    var area = (values.width * values.height) / 10000; // m²
    var unitCents = this.m2Cents * (1 + this.surcharge / 100);
    return {
      area: area,
      totalArea: area * values.qty,
      cents: Math.round(area * unitCents * values.qty),
    };
  };

  RugOptions.prototype.updateSummary = function () {
    if (!this.summary) return;
    var values = this.readCustom();
    if (isNaN(values.width) || isNaN(values.height) || values.width <= 0 || values.height <= 0) {
      this.summary.hidden = true;
      return;
    }
    var calc = this.computeCustom(values);
    this.summary.hidden = false;
    if (this.areaEl) {
      this.areaEl.textContent = formatNumber(calc.totalArea, 2) + " m²";
    }
    if (this.priceEl) {
      this.priceEl.textContent = this.m2Cents > 0 ? formatMoney(calc.cents) : "";
      this.priceEl.hidden = this.m2Cents <= 0;
    }
  };

  /* ---------- Teklif modalı ---------- */

  RugOptions.prototype.bindDialog = function () {
    if (!this.dialog) return;
    var self = this;
    var closers = this.dialog.querySelectorAll("[data-quote-close]");
    Array.prototype.forEach.call(closers, function (el) {
      el.addEventListener("click", function () {
        self.closeQuote();
      });
    });
    this.dialog.addEventListener("click", function (event) {
      if (event.target === self.dialog) self.closeQuote();
    });
    // Teklif formu gönderildikten sonra sayfa yenilenir; sonucu göstermek için
    // modalı tekrar açıyoruz.
    if (this.dialog.querySelector("[data-quote-status]")) {
      this.showDialog();
    }
  };

  RugOptions.prototype.showDialog = function () {
    if (!this.dialog) return;
    if (typeof this.dialog.showModal === "function") {
      if (!this.dialog.open) this.dialog.showModal();
    } else {
      this.dialog.setAttribute("open", "open");
    }
  };

  RugOptions.prototype.closeQuote = function () {
    if (!this.dialog) return;
    if (typeof this.dialog.close === "function") {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute("open");
    }
  };

  RugOptions.prototype.openQuote = function () {
    var values = this.readCustom();
    var errors = this.customErrors(values);
    if (errors.length) {
      this.custom.classList.add("is-invalid");
      if (this.errorEl) this.errorEl.textContent = errors[0];
      return;
    }
    this.custom.classList.remove("is-invalid");

    var calc = this.computeCustom(values);
    var edge = this.selectedEdge();
    var note = this.noteInput ? this.noteInput.value.trim() : "";
    var size = formatNumber(values.width, 0) + " x " + formatNumber(values.height, 0) + " cm";
    var areaText = formatNumber(calc.totalArea, 2) + " m²";
    var priceText = this.m2Cents > 0 ? formatMoney(calc.cents) : "—";

    this.fill("[data-quote-field-size]", size);
    this.fill("[data-quote-field-area]", areaText);
    this.fill("[data-quote-field-qty]", String(values.qty));
    this.fill("[data-quote-field-edge]", edge || "Belirtilmedi");
    this.fill("[data-quote-field-price]", priceText);
    this.fill("[data-quote-field-note]", note);

    this.setText("[data-recap-size]", size);
    this.setText("[data-recap-area]", areaText);
    this.setText("[data-recap-qty]", String(values.qty));
    this.setText("[data-recap-edge]", edge || "Belirtilmedi");
    this.setText("[data-recap-price]", priceText);

    var body = this.dialog && this.dialog.querySelector("[data-quote-body]");
    if (body && !body.value.trim()) {
      body.value =
        "Özel ölçü talebim: " +
        size +
        " (" +
        areaText +
        "), " +
        values.qty +
        " adet" +
        (edge ? ", kenar işçiliği: " + edge : "") +
        "." +
        (note ? "\n\nNot: " + note : "");
    }

    this.showDialog();
  };

  RugOptions.prototype.fill = function (selector, value) {
    if (!this.dialog) return;
    var el = this.dialog.querySelector(selector);
    if (el) el.value = value;
  };

  RugOptions.prototype.setText = function (selector, value) {
    if (!this.dialog) return;
    var el = this.dialog.querySelector(selector);
    if (el) el.textContent = value;
  };

  /* ---------- Sepete ekle doğrulaması ---------- */

  RugOptions.prototype.bindAddToCartGuard = function () {
    var self = this;
    // Tema, form submit olayını kendi dinlediği için tıklamayı capture
    // aşamasında yakalayıp geçersiz seçimde submit'i hiç başlatmıyoruz.
    document.addEventListener(
      "click",
      function (event) {
        var button = event.target && event.target.closest
          ? event.target.closest('button[type="submit"][name="add"]')
          : null;
        if (!button) return;
        var form = button.form || button.closest("form");
        if (!form) return;

        var isMain = form === self.productForm;
        var isSticky = form === self.stickyForm();
        if (!isMain && !isSticky) return;

        if (self.edgeRequired && self.edgeGroup && !self.validateEdge()) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        // Sticky formda inputlarımız yok; değerleri oraya taşı.
        if (isSticky) self.mirrorInto(form);
      },
      true
    );
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll(".rug-options:not([data-rug-ready])");
    Array.prototype.forEach.call(roots, function (root) {
      root.setAttribute("data-rug-ready", "true");
      try {
        new RugOptions(root);
      } catch (e) {
        console.error("[rug-options]", e);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  document.addEventListener("shopify:block:select", function (event) {
    init(event.target);
  });
})();
